export const EDIT_MODE = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  ASSIGN_PRINTER: 'ASSIGN_PRINTER',
  SET_WORKFLOW: 'SET_WORKFLOW',
  REMOVE: 'REMOVE',
}



/** WEBPACK FOOTER **
 ** ./client/pages/kitchen-department/constants.js
 **/